import { Show } from './types';

export const shows: Show[] = [
  { title: 'Gold Digger', thumbnail: './Gold Digger.jpeg'  },
  { title: 'Liar', thumbnail: './Liar.jpeg'  },
  { title: 'Little Women: LA', thumbnail: './Little Women- LA.jpeg' },
  { title: 'My Kitchen Rules', thumbnail: './MKR.jpeg' },
  { title: 'Pooch Perfect', thumbnail: './Pooch Perfect.jpeg' },
  { title: 'Revolution', thumbnail: './Revolution.jpeg' },
  { title: 'Smallville', thumbnail: './Smallville.jpeg' },
  { title: 'The Good Doctor', thumbnail: './The Good Doctor.jpeg' },
  { title: 'The Resident', thumbnail: './The Resident.jpeg' },
  { title: 'Transformed', thumbnail: './Transformed.jpeg' },
]